import { useParams } from 'react-router'

import ArticlePage from './components/ArticlePage'
import ColophonPage from './components/ColophonPage'
import CoverPage from './components/CoverPage'
import { useMagazineView } from './MagazineViewContext'

export const CoverPageRoute = () => {
    return <CoverPage />
}

export const ColophonPageRoute = () => {
    const { magazineIssue } = useMagazineView()
    const colophon = magazineIssue.colophon.filter((field) => field.value)

    return <ColophonPage colophon={colophon} />
}

export const ArticlePageRoute = () => {
    const { magazineIssue, articles } = useMagazineView()
    const { guid } = useParams()
    const currentArticle = articles?.find((a) => a.guid === guid) ?? null

    if (!currentArticle) {
        return null
    }

    return (
        <ArticlePage
            container={magazineIssue.container}
            article={currentArticle}
        />
    )
}
